import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import getWebShellProductQueryKey from './get-query-key';
import getWebShellClientLocale from "../../../utils/get-webshellclient-locale";
var getWebShellProductOptions = function getWebShellProductOptions() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    productCode = _ref.productCode;
  var _getWebShellClientLoc = getWebShellClientLocale(),
    country = _getWebShellClientLoc.country,
    language = _getWebShellClientLoc.language;
  var marketplace = country === null || country === void 0 ? void 0 : country.toUpperCase();
  return {
    queryKey: getWebShellProductQueryKey({
      productCode: productCode,
      marketplace: marketplace,
      language: language
    }),
    queryFn: function () {
      var _queryFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var capability;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return window.webShellClient.__WS_UNSTABLE__.getCapability('product');
            case 1:
              capability = _context.sent;
              return _context.abrupt("return", capability.get({
                productCode: productCode,
                marketplace: marketplace,
                language: language
              }));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function queryFn() {
        return _queryFn.apply(this, arguments);
      }
      return queryFn;
    }(),
    enabled: Boolean(productCode && marketplace && language),
    // WebShell owns data freshness — prevent React Query from triggering redundant background refetches.
    staleTime: Infinity,
    // Products go inactive / out of stock; the capability returns "not found" for those productCodes.
    // Don't retry — mirrors the legacy merch/skus/v2 + available_gtins/v3 404-no-retry pattern.
    retry: function retry(_failureCount, error) {
      var _error$response;
      return (error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) !== 404;
    }
  };
};
export default getWebShellProductOptions;